import { FC } from "react";
import { Flex, Heading } from "@smile2impress/components/relaunch";

import { ImageCard } from "./components/ImageCard";
import { ImageCardGridProps } from "./ImageCardGrid.types";

export const ImageCardGrid: FC<ImageCardGridProps> = ({ content }) => {
    const { title, items } = content;

    return (
        <Flex as="section" direction="column" gap={[3, 3, 4]} px={[0, 0, 4]}>
            <Heading
                w={["auto", "auto", "800px"]}
                textStyle={["title1"]}
                color="text.base"
            >
                {title}
            </Heading>

            <Flex direction={["column", "column", "row"]} gap={[1, 1, 4]}>
                {items.map((item, index) => (
                    <ImageCard key={`${item.title}-${index}`} {...item} />
                ))}
            </Flex>
        </Flex>
    );
};
